
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.674 12.5a.654.654 0 01-.58-.333.72.72 0 01-.093-.326.593.593 0 01.093-.341L6.403.833a.663.663 0 01.265-.25A.72.72 0 017 .5c.113 0 .224.028.332.083a.653.653 0 01.264.25l6.31 10.667c.067.111.099.225.093.342a.708.708 0 01-.094.325.672.672 0 01-.238.242.636.636 0 01-.341.091H.674zM7 10.5a.668.668 0 00.486-.192.635.635 0 00.196-.475A.666.666 0 007 9.166a.666.666 0 00-.682.667A.663.663 0 007 10.5zm0-2a.668.668 0 00.486-.192.635.635 0 00.196-.475v-2a.636.636 0 00-.197-.474A.671.671 0 007 5.167a.664.664 0 00-.682.666v2A.665.665 0 007 8.5z","fill":"#FFA600"}})])
          )
        }
      }
    